import { Action } from 'redux';

import { fetchFavoriteEntities } from './favoriteEntities';
import { deleteAllFavorites } from '../../api/deleteAllFavorites';
import {
  FAVORITE_ENTITIES_REMOVE_ALL_FETCH,
  FAVORITE_ENTITIES_REMOVE_ALL_FAIL,
  FAVORITE_ENTITIES_REMOVE_ALL_SUCCESS,
} from '../../constants/actionTypes';
import { EEntityType } from '../../repositories/favorites/v1/web-delete-favorites';
import { ENotificationStyle } from '../../types/notifications';
import { TThunkAction } from '../../types/redux';
import { trackPageview } from '../../utils/trackPageview';
import { notify } from '../notifications';

export type TRemoveAllFetch = 'favoriteEntities/remove_all_fetch';
export type TRemoveAllSuccess = 'favoriteEntities/remove_all_success';
export type TRemoveAllFail = 'favoriteEntities/remove_all_fail';

export interface IRemoveAllFetch extends Action<TRemoveAllFetch> {
  type: TRemoveAllFetch;
}

export interface IRemoveAllSuccess extends Action<TRemoveAllSuccess> {
  type: TRemoveAllSuccess;
}

export interface IRemoveAllFail extends Action<TRemoveAllFail> {
  type: TRemoveAllFail;
}

export type TRemoveAllActions = IRemoveAllFetch | IRemoveAllSuccess | IRemoveAllFail;

export function removeAll(): TThunkAction {
  return (dispatch, getState, context) => {
    dispatch<IRemoveAllFetch>({ type: FAVORITE_ENTITIES_REMOVE_ALL_FETCH });

    const {
      page,
      user,
      filters: { dealType, favoriteEntityType },
    } = getState();

    return deleteAllFavorites(context, {
      dealType: dealType || undefined,
      entityType: (favoriteEntityType as unknown as EEntityType) || undefined,
    })
      .then(response => {
        if (response?.statusCode === 200) {
          dispatch<IRemoveAllSuccess>({ type: FAVORITE_ENTITIES_REMOVE_ALL_SUCCESS });
          // Ответ старого метода не совместим с новым форматом
          dispatch(fetchFavoriteEntities({ offset: 0 }));

          // Обновляем шапку
          if (window.refreshAfterUserLoggedIn) {
            window.refreshAfterUserLoggedIn();
          }

          const {
            results: { favoriteEntities },
          } = getState();

          trackPageview(page, user, favoriteEntities, 0);

          return;
        }

        dispatch<IRemoveAllFail>({ type: FAVORITE_ENTITIES_REMOVE_ALL_FAIL });
        dispatch(notify('Не удалось удалить. Попробуйте позже', ENotificationStyle.Error));
      })
      .catch(error => {
        context.logger.error(error);

        dispatch<IRemoveAllFail>({ type: FAVORITE_ENTITIES_REMOVE_ALL_FAIL });
        dispatch(notify('Не удалось удалить. Попробуйте позже', ENotificationStyle.Error));
      });
  };
}
